<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="page_1"></a><span class="small">PRAISE FOR</span></p>
<p class="centerb">Four and Twenty Blackbirds</p>
<p class="noindentt1">“Southern Gothic at its best. An absorbing mystery told with humor and bite.”</p>
<p class="attribute">—Kelley Armstrong, author of <em>Industrial Magic</em> and the Otherworld series</p>
<p class="noindentt1">“Cherie Priest has created a chilling page-turner in her debut novel. Her voice is rich, earthy, soulful, and deliciously Southern as she weaves a disturbing yarn like a master! Awesome—gives you goose bumps!”</p>
<p class="attribute">—L. A. Banks, author of <em>Minion</em> and The Vampire Huntress Legend series</p>
<p class="noindentt1">“Breathlessly readable, palpably atmospheric, and compellingly suspenseful, <em>Four and Twenty Blackbirds</em> is a considerable debut. It’s written with great control and fluency, and it looks like the start of quite a career.”</p>
<p class="attribute">—Ramsey Campbell, World Horror Grand Master</p>
<p class="noindentt1"><em>“Four and Twenty Blackbirds</em> is a rare bird, the novel you wish you’d written yourself—excellent!”</p>
<p class="attribute">—C. J. Henderson, author of <em>The Things That Are Not There</em></p>
<p class="noindentt1">“Wonderful. Enchanting. Amazing and original fiction that will satisfy that buttery Southern taste, as well as that biting aftertaste of the dark side. I loved it.”</p>
<p class="attribute">—Joe R. Lansdale, Stoker- and Edgar-winning author of <em>The Bottoms</em></p>
<p class="noindentt1"><a id="page_2"></a>“Cherie Priest has mastered the art of braiding atmosphere, suspense, and metaphysics into a resonant ghost story that offers even more than what you hope for.”</p>
<p class="attribute">—Katherine Ramsland, author of <em>Ghost: Investigating the Other Side</em></p>
<p class="noindentt1"><em>“Four and Twenty Blackbirds</em> is an extraordinary first novel—heck, it’s an extraordinary novel, period. It’s a ghost story and a voodoo mystery—and like any good Southern Gothic, it has a healthy obsession with race and inbreeding. But <em>Blackbirds</em> is more than the sum of its traditional parts. Cherie Priest’s writing, while decidedly capable of giving you the creeps, is infused with a refreshing spunkiness and interesting, believable characters. . . . Fans of supernatural horror should keep an eye on Cherie Priest!”</p>
<p class="attribute">—SciFiDimensions.com</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?14a53e8d